import { Cia } from "./cia.model";

export class Frota {
    Id: number;
    Codigo: string;
    CiaRodoviaria: Cia;
    CiaRodoviariaId: number
    Assentos: number;
    Descricao: string;
}